<template>
  <b-container fluid id="navbar-container">
    <b-navbar
      toggleable="xl"
      type="light"
      class="justify-content-md-center justify-content-start"
    >
      <b-navbar-toggle target="navbar-toggle-collapse" class="mr-4 ml-auto">
        <template v-slot:default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up" variant="dark" style="width: 60px; height: 60px;"></b-icon>
          <b-icon v-else icon="chevron-bar-down" variant="dark" style="width: 60px; height: 60px;"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="navbar-toggle-collapse" is-nav>
        <b-navbar-nav
          class="mx-auto justify-content-between align-items-center"
        >
          <b-nav-item v-for="link in routes" :key="link.path" :to="link.path">
            {{ link.text }}
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
import { routes } from "../router";
import BrandLogo from "../assets/logo.jpg";

export default {
  data() {
    return {
      routes,
      logo: BrandLogo,
    };
  },
};
</script>

<style lang="stylus">
/* Import theme colors palette */
@import '../css/palette.styl';

#navbar-container nav {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

#navbar-container ul .nav-link {
  margin-left: 20px;
  margin-right: 20px;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
}

@media (max-width: 768px) {
  #navbar-container ul .nav-link {
    margin-left: 10px;
    margin-right: 10px;
    font-family: 'Roboto Condensed', sans-serif;
    font-weight: 700;
    font-size: 1rem;
  }
}

#navbar-container ul .nav-link:hover {
  color: $pastelGreenColor;
  border-bottom: 2px solid $pastelGreenColor;
}

#navbar-container ul .router-link-exact-active {
  color: $navbarActiveColor;
  border-bottom: 2px solid $accentColor;
}
</style>
